import * as apiFunction from '@services/apiFunctions'

import { API_URLS } from '@services/apiRoutes'

export const getLogoutRedirectUrl = async () => {
  return await apiFunction.apiRequestWithBody({
    url: API_URLS.auth.logoutRedirectUrl,
    method: 'POST'
  })
}

export const refreshToken = async (refreshToken: string) => {
  return await apiFunction.apiRequestWithBody({
    url: API_URLS.auth.refreshToken,
    method: 'POST',
    body: { refreshToken }
  })
}

export const getExchangeAuthCode = async (code: string | null) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: API_URLS.auth.exchangeAuthCode,
    method: 'GET',
    params: { code }
  })
}

export const getLoginRedirectUrl = async () => {
  return await apiFunction.apiRequestWithQueryParams({
    url: API_URLS.auth.loginRedirectUrl,
    method: 'GET'
  })
}
